//@flow
import React from 'react';
import s from './SidePanelStyle.less';

type Props = {
  SideBarSummaryData: Object,
};

const SidePanel = (props: Props) => (
  <div className={`shadowBox sidePanelSection`}>
    {Object.keys (props.SideBarSummaryData).map (summaryGroup => {
      return (
        <div key={summaryGroup}>
          <div>
            <h2 className={`${s.summaryHeader}`}>{summaryGroup}</h2>
          </div>
          <hr className={`${s.sectionDivider}`} />
          <ul>
            {Object.keys (
              props.SideBarSummaryData[summaryGroup]
            ).map (groupItem => {
              return (
                <li key={groupItem}>
                  {groupItem}
                  <span
                 style={
                  String(props.SideBarSummaryData[summaryGroup][groupItem]).toLowerCase() === 'inactive'
                    ? {color: 'rgb(215, 29, 79)'}
                    : {color: 'black'}
            }
                  data-e2e={groupItem.replace (/ /g, '-')}>
                    {props.SideBarSummaryData[summaryGroup][groupItem]}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      );
    })}
  </div>
);

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/SidePanel/SidePanel.js